import { RouteObject } from "react-router-dom";
import ProtectedRoute from "../context/ProtectedRoute";
import MainLayout from "../layout/MainLayout";
import DashboardPage from "../pages/DashboardPage";
import DynamicLimitPage from "../pages/dynamicLimit/DynamicLimitPage";
import Error404 from '../pages/Error404';
import GameConfigPage from "../pages/games/GamesConfigPage";
import GamesPage from "../pages/games/GamesPage";
import PlayGamePage from "../pages/games/PlayGamePage";
import ChangePasswordPage from "../pages/misc/ChangePasswordPage";
import BetViewPage from "../pages/reports/BetViewPage";
import Day2DayReport from "../pages/reports/Day2DayReport";
import GameBusinessPage from "../pages/reports/GameBusinessPage";
import { default as GameReportPage, default as GameTransPage } from "../pages/reports/GameReportPage";
import PointTransPage from "../pages/reports/PointTransPage";
import PublishResultPage from "../pages/results/PublishResultPage";
import ResultTimePage from "../pages/resultTimes/ResultTimePage";
import AdminPage from "../pages/Users/AdminPage";
import AgentPage from "../pages/Users/AgentPage";
import UsersPage from "../pages/Users/UsersPage";
import ManagerPermissionPage from "../pages/admin/ManagerPermissionPage";
import ManagerPage from "../pages/Users/ManagerPage";
import SingleReportPage from "../pages/clientReports/SingleReportPage";
import PattiReportPage from "../pages/clientReports/PattiReportPage";
import ScheduledBetsPage from "../pages/reports/ScheduledBetsPage";


const routes: RouteObject[] = [
  {
    path: "/",
    element: <ProtectedRoute requiredRoles={[]} element={<MainLayout />} />,
    errorElement: <Error404 />,
    children: [
      {
        path: "/",
        element: <ProtectedRoute requiredRoles={[]} element={<DashboardPage />} /> ,
      }, 
      {
        path: "/dashboard",
        element: <ProtectedRoute requiredRoles={[]} element={<DashboardPage />} /> ,
      },    
      {
        path: "/users",
        element: <UsersPage />,
      },
      {
        path: "/reports/singleReport",
        element: <SingleReportPage />,
      },
      {
        path: "/reports/pattiReport",
        element: <PattiReportPage />,
      },
      {
        path: "/admins",
        element: <AdminPage />,
      },
      {
        path: "/managers",
        element: <ManagerPage />,
      },
      {
        path: "/agents",
        element: <AgentPage />,
      },
      {
        path: "/games",
        element: <GamesPage />,
      },
      {
        path: "/playGame",
        element: <PlayGamePage />,
      },
      {
        path: '/games/config',
        element: <GameConfigPage />
      },
      {
        path: '/resultTimes',
        element: <ResultTimePage />
      },
      {
        path: "/reports/pointTrans",
        element: <PointTransPage />,
      },
      {
        path: '/reports/betView',
        element: <BetViewPage />
      },
      {
        path: "/reports/trans",
        element: <Day2DayReport />,
      },
      {
        path: "/reports/gameTrans",
        element: <GameTransPage />,
      },
      {
        path: "/reports/scheduled-bets",
        element: <ScheduledBetsPage />,
      },
      {
        path: "/reports/custTrans",
        element: <Day2DayReport />,
      },
      {
        path: "/reports/gameReport",
        element: <GameReportPage />,
      },
      {
        path: "/changePassword",
        element: <ChangePasswordPage />,
      },
      {
        path: "/reports/business",
        element: <GameBusinessPage />,
      },
      {
        path: "/results",
        element: <PublishResultPage />,
      },
      {
        path: '/dynamicLimit',
        element: <DynamicLimitPage />
      },
      {
        path: '/manager/permissions',
        element: <ManagerPermissionPage />
      }
    ]
  },
];

export default routes;